<article
  class="flex flex-col w-full bg-base-100 border rounded-xl shadow-sm overflow-hidden transition-all duration-200"
  [class.border-primary/30]="open()"
  [class.shadow-md]="open()"
  [class.border-base-300]="!open()">
  <!-- 헤더 -->
  <button
    class="flex items-center justify-between w-full px-6 py-4 cursor-pointer hover:bg-base-200/50 transition-colors"
    (click)="toggle()">
    <div class="flex items-center gap-3">
      <div
        class="w-1 rounded-full"
        [class.transition-all]="animated()"
        [class.duration-200]="animated()"
        [class.h-6]="open()"
        [class.h-5]="!open()"
        [class.bg-primary]="open()"
        [class.bg-primary/40]="!open()"></div>
      <h3 class="text-lg font-bold text-base-content select-none">
        {{ title() }}
      </h3>
      <span
        class="flex items-center justify-center w-6 h-6 rounded-full"
        [class.transition-all]="animated()"
        [class.duration-250]="animated()"
        [class.bg-primary/10]="open()"
        [class.bg-base-200]="!open()">
        <span
          class="icon-[mdi--chevron-down] text-base"
          [class.transition-all]="animated()"
          [class.duration-250]="animated()"
          [class.rotate-180]="open()"
          [class.text-primary]="open()"
          [class.text-base-content/40]="!open()">
        </span>
      </span>
    </div>
    <div class="flex items-center gap-3">
      <button class="cursor-default" (click)="slotClick($event)">
        <ng-content select="[headerContent]" />
      </button>
      <button class="flex items-center gap-2 cursor-default" (click)="slotClick($event)">
        <ng-content select="[buttons]" />
      </button>
    </div>
  </button>

  <!-- 바디 (슬라이드 애니메이션) -->
  <div class="accordion-body" [class.accordion-body-open]="open()" [class.enable-transition]="animated()">
    <div class="overflow-hidden">
      <div class="mx-6 border-t border-base-200"></div>
      <div class="flex flex-col gap-6 px-6 py-5">
        <ng-content />
      </div>
    </div>
  </div>
</article>
